/*
  (C) Belvano Cart-Upsell — Varianten-Swap im Warenkorb-Drawer.
  Klick auf "Dazu" tauscht die Line-Item-Variante auf die Kombi-Variante
  (z. B. "Mit Nachttischen"), "✓ Dabei" tauscht zurück. Ablauf:
  cart/change (Zeile per Key entfernen) → cart/add (Ziel-Variante) →
  Drawer-HTML frisch holen (?section_id=helper-cart) und ersetzen — der
  Server rendert Karten-Zustände und Zwischensumme dann korrekt neu.
*/
if ( typeof customElements.get('belvano-cart-upsell') == 'undefined' ) {

	class BelvanoCartUpsell extends HTMLElement {

		connectedCallback() {
			this.querySelectorAll('[data-bvu-swap]').forEach(btn => {
				btn.addEventListener('click', () => this.swap(btn));
			});
			this.querySelectorAll('[data-bvu-zoom]').forEach(media => {
				media.addEventListener('click', () => this.openZoom(media));
				media.addEventListener('keydown', e => {
					if ( e.key === 'Enter' || e.key === ' ' ) {
						e.preventDefault();
						this.openZoom(media);
					}
				});
			});
		}

		openZoom(media) {
			const existing = document.querySelector('.bvu-zoom');
			if ( existing ) existing.remove();
			const label = media.getAttribute('aria-label') || '';
			const wrap = document.createElement('div');
			wrap.className = 'bvu-zoom';
			wrap.innerHTML = `
				<div class="bvu-zoom__backdrop"></div>
				<div class="bvu-zoom__panel" role="dialog" aria-label="${label}">
					<button type="button" class="bvu-zoom__close" aria-label="Schliessen">&times;</button>
					<img src="${media.dataset.bvuZoom}" alt="${label}">
				</div>`;
			document.body.appendChild(wrap);
			const close = () => {
				wrap.remove();
				document.removeEventListener('keydown', onKey);
			};
			const onKey = e => { if ( e.key === 'Escape' ) close(); };
			wrap.querySelector('.bvu-zoom__backdrop').addEventListener('click', close);
			wrap.querySelector('.bvu-zoom__close').addEventListener('click', close);
			document.addEventListener('keydown', onKey);
		}

		async swap(btn) {
			if ( this._working ) return;
			this._working = true;
			btn.classList.add('working');
			btn.disabled = true;

			const lineKey = btn.dataset.lineKey;
			const targetId = parseInt(btn.dataset.targetVariant, 10);
			const qty = parseInt(btn.dataset.qty || '1', 10) || 1;

			// Shopify sortiert den Warenkorb seit API 2023-10 „neueste zuerst" und kennt
			// KEINE Reorder-Operation. Ein Varianten-Tausch = alte Zeile entfernen + Ziel
			// neu einfügen macht die Zeile zur neuesten → sie springt nach oben. Um die
			// Position zu halten, fügen wir die ursprünglich DARÜBER liegenden Zeilen
			// mit-neu-ein; die Reihenfolge steuert die Array-Position im add (zuletzt =
			// neueste = oben). Gebündelt in nur 2 Requests (1× update entfernt alles,
			// 1× add fügt in Reihenfolge ein UND rendert die Section gleich mit) — schnell
			// und unabhängig von der Anzahl der Zeilen darüber.
			// (Basis ist immer der Drawer/Cart-Page-Beleg #AjaxCartForm, auch wenn der
			// Klick aus der geklonten Popup-Karte kommt.)
			const form = document.getElementById('AjaxCartForm');
			const rows = form ? Array.from(form.querySelectorAll('[data-js-cart-item]')) : [];
			const idx = rows.findIndex(r => r.dataset.id === lineKey);
			const clickedVariant = idx >= 0 ? parseInt(rows[idx].dataset.variant, 10) : NaN;
			const above = idx > 0
				? rows.slice(0, idx)
					.map(r => ({ id: parseInt(r.dataset.variant, 10), quantity: parseInt(r.dataset.qty || '1', 10) || 1 }))
					.filter(r => r.id)
				: [];

			const post = (route, body) => fetch(`${route}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body: JSON.stringify(body)
			}).then(r => r.json());

			try {
				if ( above.length && clickedVariant ) {
					// 1) alte Zeile + alle darüber in EINEM update entfernen (Varianten sind
					//    hier pro Zeile eindeutig, weil gleiche Variante ohnehin zusammenfällt).
					const updates = {};
					updates[clickedVariant] = 0;
					above.forEach(a => { updates[a.id] = 0; });
					await post(KROWN.settings.routes.cart_update_url, { updates });
					// 2) Ziel zuerst (= unterste/älteste der Gruppe), dann die darüber von
					//    unten nach oben (oberste zuletzt = neueste) — in EINEM add.
					const items = [{ id: targetId, quantity: qty }]
						.concat(above.slice().reverse().map(a => ({ id: a.id, quantity: a.quantity })));
					const res = await post(KROWN.settings.routes.cart_add_url, { items, sections: 'helper-cart', sections_url: window.location.pathname });
					this.applySection(res && res.sections && res.sections['helper-cart']);
				} else {
					// Klick auf die oberste Zeile (oder DOM ohne data-variant) → kein Reorder
					// nötig: entfernen + Ziel einfügen, Section gleich mitrendern.
					await post(KROWN.settings.routes.cart_change_url, { id: lineKey, quantity: 0 });
					const res = await post(KROWN.settings.routes.cart_add_url, { items: [{ id: targetId, quantity: qty }], sections: 'helper-cart', sections_url: window.location.pathname });
					this.applySection(res && res.sections && res.sections['helper-cart']);
				}
			} catch (e) {
				// Zustand unklar (z. B. update ok, add fehlgeschlagen) →
				// Drawer sicher neu laden, damit UI und Cart übereinstimmen.
				console.log(e);
				this.refreshDrawer();
			}
		}

		// Fallback-Nachladen der Section per eigenem Request (wenn kein gebündeltes
		// sections-HTML aus cart/add.js vorliegt oder ein Fehler auftrat).
		refreshDrawer() {
			fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => this.applySection(text))
				.catch(e => console.log(e));
		}

		// Gerendertes helper-cart-HTML in Drawer/Cart-Page einsetzen (Items, Zwischensumme,
		// Header-Zähler). Quelle: entweder cart/add.js `sections` (schnell) oder refreshDrawer.
		applySection(html) {
			if ( !html ) { this.refreshDrawer(); return; }

			const sectionInnerHTML = new DOMParser().parseFromString(html, 'text/html');
			const cartItems = document.getElementById('AjaxCartForm');
			const cartSubtotal = document.getElementById('AjaxCartSubtotal');

			if ( cartItems && sectionInnerHTML.getElementById('AjaxCartForm') ) {
				cartItems.innerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				if ( typeof cartItems.ajaxifyCartItems === 'function' ) {
					cartItems.ajaxifyCartItems();
				}
				document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
					const count = cartItems.querySelector('[data-cart-count]');
					if ( count ) elm.textContent = count.textContent;
				});
				document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
					const total = cartItems.querySelector('[data-cart-total]');
					if ( total ) elm.textContent = total.textContent;
				});
				cartItems.dispatchEvent(new Event('cart-updated'));
			}
			if ( cartSubtotal && sectionInnerHTML.getElementById('AjaxCartSubtotal') ) {
				cartSubtotal.innerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
			}
		}

	}

	customElements.define('belvano-cart-upsell', BelvanoCartUpsell);

}